var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        [
          _vm._l(_vm.input, function(answerType, atIndex) {
            return _c(
              "div",
              {
                key: `at-${atIndex}`,
                staticClass: "mt-4 row align-items-center justify-content-start"
              },
              [
                _c("input", {
                  staticClass: "custom-radio ms",
                  attrs: { disabled: "", type: "radio" }
                }),
                _c(
                  "div",
                  { staticClass: "col-8 col-lg-4" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: answerType.name,
                                    callback: function($$v) {
                                      _vm.$set(answerType, "name", $$v)
                                    },
                                    expression: "answerType.name"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                atIndex > 1
                  ? _c("div", { staticClass: "col-2 col-lg-3" }, [
                      _c("i", {
                        staticClass: "far fa-times-circle text-danger",
                        on: {
                          click: function($event) {
                            return _vm.triggerConfirmation(atIndex)
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ]
            )
          }),
          _c(
            "div",
            {
              staticClass: "mt-4 row align-items-center justify-content-start"
            },
            [
              _vm.canAddMore
                ? _c("input", {
                    staticClass: "custom-radio",
                    attrs: { disabled: "", type: "radio" }
                  })
                : _vm._e(),
              _vm.canAddMore
                ? _c("div", { staticClass: "col-8 col-lg-2" }, [
                    _c(
                      "u",
                      {
                        staticClass: "add-button",
                        on: { click: _vm.addAnswer }
                      },
                      [_vm._v(" Agregar una opción ")]
                    )
                  ])
                : _vm._e(),
              _c("input", {
                staticClass: "custom-radio",
                attrs: { disabled: "", type: "radio" }
              }),
              _c("div", { staticClass: "col-8 col-lg-2" }, [
                _c(
                  "u",
                  { staticClass: "add-button", on: { click: _vm.addChild } },
                  [_vm._v(" Agregar Dependencia ")]
                )
              ])
            ]
          ),
          _vm._l(_vm.childQuestions, function(child, cqIndex) {
            return _c(
              "div",
              {
                key: `cq-${cqIndex}`,
                staticClass:
                  "ml-3 mt-4 row border-start border-1 align-items-center justify-content-start custom-border w-75 p-3"
              },
              [
                _c("div", { staticClass: "col-12 pb-2 border-bottom row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("i", { staticClass: "fas fa-pen text-orange mr-2" }),
                    _c("span", { staticClass: "custom-sub-title" }, [
                      _vm._v(_vm._s(_vm.title(child, cqIndex)))
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-2 d-flex justify-content-end" },
                    [
                      _c("i", {
                        staticClass: "far fa-times-circle text-danger",
                        on: {
                          click: function($event) {
                            return _vm.triggerSubAnwserConfirmation(cqIndex)
                          }
                        }
                      })
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "my-2 col-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(" Pregunta o Descripción: ")
                                ]),
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campor es requerido.",
                                    error: errors[0],
                                    maxlength: "500",
                                    placeholder:
                                      "Escribe tu Pregunta o Descripción"
                                  },
                                  model: {
                                    value: child.name,
                                    callback: function($$v) {
                                      _vm.$set(child, "name", $$v)
                                    },
                                    expression: "child.name"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 my-2" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(" Opción de Respuesta: ")
                                ]),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: child.typeId,
                                        expression: "child.typeId"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: { error: errors.length > 0 },
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      placeholder: "Seleccione"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          child,
                                          "typeId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          disabled: "",
                                          hidden: "",
                                          selected: "",
                                          value: ""
                                        }
                                      },
                                      [_vm._v(" Seleccione ")]
                                    ),
                                    _vm._l(_vm.availableAnswersTypes, function(
                                      type,
                                      aatIndex
                                    ) {
                                      return _c("option", {
                                        key: `aat-${aatIndex}`,
                                        staticClass: "fa",
                                        domProps: {
                                          value: type.id,
                                          innerHTML: _vm._s(
                                            `${type.icon} ${type.name}`
                                          )
                                        }
                                      })
                                    })
                                  ],
                                  2
                                ),
                                errors.length > 0
                                  ? _c("custom-error", {
                                      attrs: {
                                        message: "El campo es requerido",
                                        variant: "no-border mt-1"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-md-6 my-2",
                    on: {
                      click: function($event) {
                        return _vm.getUnselected(child)
                      }
                    }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(" Enlazar a: ")
                                ]),
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    "custom-error-msg": "Favor Seleccionar",
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    options: _vm.availableOptions,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: child.linkedAnswer,
                                    callback: function($$v) {
                                      _vm.$set(child, "linkedAnswer", $$v)
                                    },
                                    expression: "child.linkedAnswer"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 my-2" },
                  [
                    child.typeId == _vm.selection.simpleVertical
                      ? _c("vertical-inputs", {
                          attrs: { input: child.answers },
                          on: {
                            "update:input": function($event) {
                              return _vm.$set(child, "answers", $event)
                            }
                          }
                        })
                      : _vm._e(),
                    child.typeId == _vm.selection.multipleHorizontal
                      ? _c("multiple-selection", {
                          attrs: {
                            input: child.answers,
                            orientation: "horizontal"
                          },
                          on: {
                            "update:input": function($event) {
                              return _vm.$set(child, "answers", $event)
                            }
                          }
                        })
                      : _vm._e(),
                    child.typeId == _vm.selection.multipleVertical
                      ? _c("multiple-selection", {
                          attrs: {
                            input: child.answers,
                            orientation: "vertical"
                          },
                          on: {
                            "update:input": function($event) {
                              return _vm.$set(child, "answers", $event)
                            }
                          }
                        })
                      : _vm._e(),
                    child.typeId == _vm.selection.numericalText
                      ? _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "text" }, [
                              _vm._v(" Texto Numérico: ")
                            ]),
                            _c("input", {
                              staticClass: "form-control custom-bg-disabled",
                              attrs: {
                                disabled: "",
                                min: 0,
                                placeholder: "0",
                                type: "number"
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    child.typeId == _vm.selection.openText
                      ? _c("div", { staticClass: "row mt-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("div", { staticClass: "text" }, [
                                _vm._v(" Texto Abierto: ")
                              ]),
                              _c("custom-text-area", {
                                attrs: {
                                  disabled: "",
                                  maxlength: 0,
                                  placeholder: "Escriba un comentario"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    child.typeId == _vm.selection.simpleHorizontal
                      ? _c("horizontal-inputs", {
                          attrs: { input: child.answers },
                          on: {
                            "update:input": function($event) {
                              return _vm.$set(child, "answers", $event)
                            }
                          }
                        })
                      : _vm._e(),
                    child.typeId == _vm.selection.document
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 my-5 p-3 document-bg rounded-lg",
                            staticStyle: { "background-color": "#F1F6F4" }
                          },
                          [
                            _c("label", { staticClass: "data-label" }, [
                              _vm._v(" Archivo ")
                            ]),
                            _c("action-button", {
                              staticClass: "w-100 disabled",
                              attrs: {
                                disabled: true,
                                i: "fas fa-file-plus",
                                text: "Presione aquí para anejar documento",
                                variant: "outline-grey mr-3 pl-3 pr-4"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }